import _ from "lodash"

export default {
    formatAjaxError(error) {
        let msg = "";
        if (!_.isUndefined(error.errors)) {
            msg = error.message + "<br>\n";
            Object.values(error.errors).forEach(d => {
                msg += d + "<br>\n";
            })
        } else {
            msg = error.message + "<br>\n";
        }
        return msg;
    },

    handleGlobalError(error) {
        let errorString = this.formatAjaxError(
            error.response.data
        );
        window.Vue.fire({
            title: "Errore",
            html: errorString,
            type: "error"
        });
    },

    getImagePath(id) {
        let normId = id.toString().replace("/", "_") + ".jpg";
        return "/images/catalog/lower/" + normId;
    },
}
